module.exports = __webpack_public_path__ + "img/heatmap.3e87c172.jpg";